import React from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { images } from 'assets/themes';
import useUniversalStore from 'store/universalStore';
import useOffcanvasStore from 'store/offcanvasStore';

function Header() {
    const { openOffcanvas } = useOffcanvasStore();
    const { userBasic, accountId } = useUniversalStore((state) => state);
    const location = useLocation();
    const footerPaths = ['/settings', '/profile', '/help', '/sahukari'];
    const showFooter = footerPaths.includes(location.pathname);

    return (
        <>
            <nav className="navbar navbar-expand border-bottom shadow-sm">
                <div className="container-fluid">
                    <span className="me-auto">
                        <Link className="navbar-brand" to="/" title="Home">
                            <img src={images.logo}
                                height="50" />
                        </Link>
                    </span>
                    <div className='d-none d-md-flex w-100'>
                        <div className="collapse navbar-collapse" id="myNav">
                            <ul className="navbar-nav align-items-center me-auto">
                                <li className="nav-item mx-lg-2">
                                    <NavLink className="nav-link fs-6 text-uppercase"
                                        to="/">
                                        Cashbook
                                    </NavLink>
                                </li>
                                <li className="nav-item mx-lg-2">
                                    <NavLink className="nav-link fs-6 text-uppercase"
                                        to="/khatabook">
                                        Khata
                                    </NavLink>
                                </li>
                                <li className="nav-item mx-lg-2">
                                    <NavLink className="nav-link fs-6 text-uppercase"
                                        to="/collections">
                                        Collections
                                    </NavLink>
                                </li>
                                <li className="nav-item mx-lg-2">
                                    <NavLink className="nav-link fs-6 text-uppercase"
                                        to="/reports">
                                        Reports{' '}
                                    </NavLink>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <NavLink className="d-none d-md-flex nav-link fs-6 text-nowrap text-uppercase mx-4"
                        to="/sahukari"
                        rel="noopener noreferrer">
                        Give Credit
                    </NavLink>
                    {/* <NavLink className="d-none d-md-flex nav-link fs-6 text-uppercase me-4"
                        to="/loanapp">
                        Loans
                    </NavLink> */}
                    <a className="nav-link d-flex align-items-center"
                        onClick={() => openOffcanvas('menu')}
                        role="button">
                        <span className="fs-6 mx-3 d-none d-md-block text-nowrap text-truncate">{userBasic?.business?.name}</span>
                        <i className="bi bi-person-circle fs-1 d-none d-md-block text-app"></i>
                        <i className="bi bi-list fs-1 d-md-none"></i>
                    </a>
                </div>
            </nav>

            {/* Mobile Footer */}
            {!accountId && !showFooter && <nav className="navbar fixed-bottom py-0 border-top bg-white d-md-none bottom-nav">
                <div className="container-fluid justify-content-around">
                    <NavLink to="/" className="nav-link text-secondary d-flex flex-column align-items-center py-1">
                        <i className="bi bi-cash-stack fs-5"></i>
                        <span className="fs-extra-small">Cashbook</span>
                    </NavLink>
                    <NavLink
                        to="/sahukari"
                        className="nav-link d-flex flex-column align-items-center"
                    >
                        <div
                            className="bg-white rounded-circle d-flex align-items-center justify-content-center border-app"
                            style={{ width: "56px", height: "56px", marginTop: "-30px" }}
                        >
                            <img src={images.logo} height="30" width="30" alt="Sahukari" />
                        </div>
                        <span className="fs-extra-small mt-1 text-secondary">
                            Give Credit
                        </span>
                    </NavLink>
                    <NavLink to="/khatabook" className="nav-link text-secondary d-flex flex-column align-items-center py-1">
                        <i className="bi bi-journal-text fs-5"></i>
                        <span className="fs-extra-small">Khata</span>
                    </NavLink>
                    <NavLink to="/collections" className="nav-link text-secondary d-flex flex-column align-items-center py-1">
                        <i className="bi bi-wallet fs-5"></i>
                        <span className="fs-extra-small">Collections</span>
                    </NavLink>
                    {/* <NavLink to="/passbook" className="nav-link text-secondary d-flex flex-column align-items-center py-1 disabled opacity-50">
                        <i className="bi bi-bank fs-5"></i>
                        <span className="fs-extra-small">Passbook</span>
                    </NavLink>
                    <a role='button' onClick={() => openOffcanvas('menu')} className="nav-link text-secondary d-flex flex-column align-items-center py-1">
                        <i className="bi bi-three-dots-vertical fs-5"></i>
                        <span className="fs-extra-small">More</span>
                    </a> */}
                    {/* <NavLink to="/passbook" className="nav-link text-light d-flex flex-column align-items-center py-1 disabled opacity-50">
                        <i className="bi bi-bank fs-5"></i>
                        <span className="fs-extra-small">Passbook</span>
                    </NavLink>
                    <NavLink to="/reports" className="nav-link text-light d-flex flex-column align-items-center py-1 disabled opacity-50">
                        <i className="bi bi-bar-chart fs-5"></i>
                        <span className="fs-extra-small">Reports</span>
                    </NavLink> */}
                </div>
            </nav>}
        </>
    )
}
export default Header
